<template>
  <div id="about-maindiv" class="page-maindiv">
    <!-- Main -->
    <div id="about" class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t("cerca_nel_sito").toUpperCase() }}
        </div>
      </div>
      <div class="area-description">
        <b-input-group>
          <b-input-group-prepend style="height: 40px" is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input style="height: 40px" type="search" placeholder="" @search="search()" v-model="searchTerm"></b-form-input>
          <b-input-group-append>
            <b-button variant="info" @click="search()">{{ $t("Cerca")}}</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div v-if="searchTerm.length < 3" class="area-description" style="font-size: small; margin-top: 0">Inserisci almeno 3 caratteri</div>
      <div class="area-description">
        <div><b-spinner class="spinner" style="width: 3rem;height: 3rem" label="Busy" v-if="loading"></b-spinner></div>
        <b-container fluid>
          <b-row class="mt-2" v-for="collection in collections" :key="collection.id">
            <b-col>
              <b-icon icon="files"></b-icon>
              <b-link :to="'/assets/' + collection.id">
                {{ $utilities.getTranslation(collection, "nome", $i18n.locale) }}
              </b-link>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-for="asset in assets" :key="asset.id">
            <b-col v-if="asset.status='published'">
              <b-icon icon="file-image"></b-icon>
              <b-link :to="'/asset/' + asset.id">
                {{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}
              </b-link>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalSearch',
  data: function() {
    return {
      loading: false,
      searchTerm: "",
      assets: [],
      collections: []
    };
  },
  created() {

  },
  computed: {
  },
  methods: {
    async search() {
      this.collections = [];
      this.assets = [];
      if (this.searchTerm.length < 3)
        return;
      this.loading = true;
      await this.searchCollections();
      await this.searchAssets();
      this.loading = false;
    },
    async searchCollections() {
      const collectionsData1 = await this.$client.getItems("collezioni", {fields: ["id", "status", "traduzioni.*"], limit: 100, filter: {
          "traduzioni.nome": {
            contains: this.searchTerm
          },
        }
      });
      const collectionsData2 = await this.$client.getItems("collezioni", {fields: ["id", "status", "traduzioni.*"], limit: 100, filter: {
          "traduzioni.descrizione": {
            contains: this.searchTerm
          },
        }
      });
      let collections = this.arrayUniqueById(collectionsData1.data.concat(collectionsData2.data));
      this.collections = collections;
    },
    async searchAssets() {
      const assetsData1 = await this.$client.getItems("beni", {fields: ["id", "status", "traduzioni.*"], limit: 100, filter: {
          "traduzioni.nome": {
            contains: this.searchTerm
          },
        }
      });
      const assetsData2 = await this.$client.getItems("beni", {fields: ["id", "status", "traduzioni.*"], limit: 100, filter: {
          "traduzioni.descrizione": {
            contains: this.searchTerm
          },
        }
      });
      let assets = this.arrayUniqueById(assetsData1.data.concat(assetsData2.data));
      this.assets = assets;
    },
    arrayUniqueById(array) {
      let a = array.concat();
      for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
          if (a[i].id === a[j].id)
            a.splice(j--, 1);
        }
      }
      return a;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected(cardIndex) {
      return this.selectedCard === cardIndex
    },
  }
}
</script>